
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Cluster_headache",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/Cluster_headache.vue